import React, { useState } from 'react';
import { Button, Modal, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardCheck, faCheck, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { useValidarInventario } from '../../../../hooks/useSngpc';

interface BotaoValidarInventarioProps {
    disabled?: boolean;
}

const BotaoValidarInventario: React.FC<BotaoValidarInventarioProps> = ({ disabled }) => {
    const [showModal, setShowModal] = useState(false);
    const validarInventarioMutation = useValidarInventario();

    const handleConfirmar = async () => {
        try {
            await validarInventarioMutation.mutateAsync();
            setShowModal(false);
        } catch (error) {
            console.error('Erro ao validar inventário:', error);
        }
    };

    return (
        <>
            <Button
                variant="warning"
                onClick={() => setShowModal(true)}
                disabled={disabled}
            >
                <FontAwesomeIcon icon={faClipboardCheck} className="me-2" />
                Validar
            </Button>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FontAwesomeIcon icon={faCheck} className="me-2 text-warning-emphasis" />
                        Validar Inventário
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center py-3">
                        <FontAwesomeIcon icon={faClipboardCheck} size="3x" className="text-warning-emphasis mb-3" />
                        <h5 className="mb-3">Confirmar Validação do Inventário</h5>
                        <p className="text-body-tertiary mb-4">
                            Tem certeza de que deseja validar o inventário atual?
                        </p>
                        <Alert variant="info" className="border border-info border-opacity-25 bg-info-subtle text-start">
                            <div className="text-info-emphasis">
                                <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                                <strong>O que acontece após a validação:</strong>
                                <ul className="mb-0 mt-2">
                                    <li>O inventário não poderá mais ser editado</li>
                                    <li>A data não poderá mais ser alterada</li>
                                    <li>O inventário ficará pronto para finalização</li>
                                </ul>
                            </div>
                        </Alert>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="warning"
                        onClick={handleConfirmar}
                        disabled={validarInventarioMutation.isPending}
                    >
                        <FontAwesomeIcon icon={faCheck} className="me-2" />
                        {validarInventarioMutation.isPending ? 'Validando...' : 'Confirmar Validação'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default BotaoValidarInventario; 